//--------------------------------------------------
// imported classes
//--------------------------------------------------
const ObjectFunc = require('../../../util/ObjectFunc')
const ClassFunc = require('../../../util/ClassFunc')
const DateTimeFunc = require('../../../util/DateTimeFunc')
const Stats = require('../../to/icehockey/Stats')
const stats = new Stats
/**
 * The BaseViewObject class acts as the base one for the common usage.
 */
const tbs_model_vo_icehockey_Stats = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_icehockey_Stats.prototype = {
    //--------------------------------------------------
    // protected method
    //--------------------------------------------------
    getStats: function() {
        return stats
    },
    getStageTypes: function() {
        return [
            { label: stats['stage-type-1'], value: '1'},
            { label: stats['stage-type-2'], value: '2'}
        ]
    },
    getModeTypes: function() {
        return [
            { label: stats['player-stats-mode-type-1'], value: '1'},
            { label: stats['player-stats-mode-type-2'], value: '2'}
        ]
    },
    getRoleTypes: function() {
        return [
            { label: stats['role-type-1'], value: 'skater'},
            { label: stats['role-type-2'], value: 'goalie'}
        ]
    },
    getDimensionTypes: function() {
        return [
            { label: stats['dimension-type-1'], value: '1'},
            { label: stats['dimension-type-2'], value: '2'},
            { label: stats['dimension-type-3'], value: '3'},
        ]
    },
    getReportTypes: function(pos) {
        if (pos == 1) {
            return [
                { label: stats['goalie-report-type-1'], value: '1' },
                { label: stats['goalie-report-type-2'], value: '2' },
                { label: stats['goalie-report-type-3'], value: '3' },
                { label: stats['goalie-report-type-4'], value: '4' },
            ]
        }
        else {
            return [
                { label: stats['skater-report-type-1'], value: '1' },
                { label: stats['skater-report-type-2'], value: '2' },
                { label: stats['skater-report-type-3'], value: '3' },
                { label: stats['skater-report-type-4'], value: '4' },
            ]
        }
    },
    getSeasonTypes: function() {
        return [
            { label: stats['league-season-type-1'], value: '1' },
            { label: stats['league-season-type-2'], value: '2' },
            { label: stats['league-season-type-3'], value: '3' },
            { label: stats['league-season-type-4'], value: '4' },
        ] 
    },
    renderSeasons: function(minSeason, maxSeason) {
        console.log('@renderSeasons', ClassFunc.getClass(minSeason), ClassFunc.getClass(maxSeason))
        if (ClassFunc.getClass(maxSeason) === 'Object') {
            maxSeason = new Date().getFullYear()
        }
        console.log('maxSeason', maxSeason)
        const seasons = []
        for (let i = maxSeason; i >= minSeason; i--) {
            seasons.push({
                label: i + '-' + (i%100 + 1),
                value: i.toString(),
            })
        }
        return seasons
    },
    renderSeason: function(season) {
        if (season) {
            return season + '-' + (season%100 + 1)
        }
    },
    renderSeasonPeriod: function(minSeason, maxSeason) {
        return stats.localeProp('season-period', {minYear: minSeason, maxYear: maxSeason})
    },
    renderLevel: function(level) {
        return stats['level-type-' + level]
    },
    renderPosition: function(position) {
        if (position > 0) {
            return stats['position-type-' + position]
        }
        else {
            return ''
        }
    },
    renderRole: function(position) {
        if (position == stats['goalies']) {
            return 'goalie'
        }
        else {
            return 'skater'
        }
    },
    renderPeriod: function(minSeason, maxSeason) {
        return minSeason + '-' + maxSeason
    },
    renderAge: function(birthday) {
        if (birthday) {
            const birthYear = new Date(birthday).getFullYear()
            const currentYear = new Date().getFullYear()
            return currentYear - birthYear
        }
    },
    renderDate: function(date) {
        return DateTimeFunc.formatDate(new Date(date))
    },
    renderShortDate: function(date) {
        return DateTimeFunc.formatDate(new Date(date), 'MM-dd')
    },
    renderBirthday: function(birthday) {
        if (birthday) {
            return DateTimeFunc.formatDate(new Date(birthday))
        }
    },
    renderGender: function(gender) {
        if (gender == stats['male']) {
            return 1
        }
        else if (gender == stats['female']) {
            return 2
        }
        else {
            return 0
        }
    },
    renderHeight: function(height) {
        if (height && !height.startsWith('0')) {
            return height + " CM"
        }
    },
    renderWeight: function(weight) {
        if (weight && !weight.startsWith('0')) {
            return weight + " KG"
        }
    },
    renderSosvp: function(sosvp) {
        return this._renderNumericValue(sosvp)
    },
    renderSosp: function(sosp) {
        return this._renderNumericValue(sosp)
    },
    renderWp: function(wp) {
        return this._renderNumericValue(wp)
    },
    renderWinsPercentage: function(wp) {
        return this._renderNumericValue(wp)
    },
    renderGaa: function(gaa) {
        return this._renderNumericValue(gaa)
    },
    renderPgp: function(pgp) {
        return this._renderNumericValue(pgp)
    },
    renderO: function(pn, ps) {
        // console.log('renderO', pn, ps)
        return ((parseInt(pn) - 1) * parseInt(ps)).toString()
    },
    renderSeq: function(seq, options, index) {
        // console.log('renderSeq', seq, options, index)
        let offset = 0
        if (options.parameters.o) {
            offset = options.parameters.o != null ? Number(options.parameters.o) : 0
        }
        else if (options.parameters.pn && options.parameters.ps) {
            offset = (Number(options.parameters.pn) - 1) * Number(options.parameters.ps)
        }
        return offset + index + 1
    },
    renderScore: function(score, oppScore) {
        return score + " : " + oppScore
    },
    _renderNumericValue: function(nv) {
        if (nv == null || isNaN(nv)) {
            return
        }
        let value = nv.toString()
        if (value.indexOf('.') == -1) {
            value += '.'
        }
        value = value.substr(0, 5)
        value = ObjectFunc.pad(value, 5, '0', true)
        return value
    },
}

module.exports = tbs_model_vo_icehockey_Stats